var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "dashboard_FILL0_wght400_GRAD0_opsz48",
    d: "M17.917,14.25V6H28v8.25ZM6,17.917V6H16.083V17.917ZM17.917,28V16.083H28V28ZM6,28V19.75H16.083V28ZM7.833,16.083H14.25V7.833H7.833ZM19.75,26.167h6.417v-8.25H19.75Zm0-13.75h6.417V7.833H19.75ZM7.833,26.167H14.25V21.583H7.833ZM14.25,16.083ZM19.75,12.417ZM19.75,17.917ZM14.25,21.583Z",
    transform: "translate(-6 -6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.8bf36463ac6a1de524384659ec9f7750.svg";
export { ForwardRef as ReactComponent };